export default __webpack_public_path__ + "static/media/note.dcf1f3b9.gif";